module.exports = __webpack_public_path__ + "static/roadmap2015-5a3f9e973222b02b89381fdda147eaba.svg";